import { render, staticRenderFns } from "./ValidityDetails.vue?vue&type=template&id=c4b7f21c&"
import script from "./ValidityDetails.vue?vue&type=script&lang=js&"
export * from "./ValidityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports